module.exports = __webpack_public_path__ + "media/images/voice04-c05b1cfbb105f1190edba3e9df614df6.jpg";